import React, { useCallback } from 'react'
import { Avatar } from '@components/Avatar/Avatar'
import { ProfileHoverCard } from '@components/ProfileHoverCard/ProfileHoverCard'
import { Box, Paragraph, Stack } from '@ui'
import { usePanelActions } from 'routes/layouts/hooks/usePanelActions'
import { useUserLookupContext } from 'use-towns-client'
import { getPrettyDisplayName } from 'utils/getPrettyDisplayName'

import { ZInceptionEvent } from '../../MessageTimeline/util/getEventsByDate'

type Props = {
    event: ZInceptionEvent
    channelName?: string
    channelEncrypted?: boolean
    userId?: string
}

export const RoomCreate = (props: Props) => {
    const { lookupUser } = useUserLookupContext()
    const { event, channelName, userId } = props

    const creator = event.content.creatorId

    const creatorUser = lookupUser(creator)
    const name = getPrettyDisplayName(creatorUser)
    const groupName = channelName ? `#${channelName}` : `this group`

    const { openPanel } = usePanelActions()

    const handleCreatorClick = useCallback(
        (e: React.MouseEvent) => {
            e.preventDefault()
            if (creator) {
                openPanel('profile', { profileId: creator })
            }
        },
        [openPanel, creator],
    )

    if (!creatorUser) {
        return (
            <Stack centerContent paddingX="lg" paddingY="sm" color="gray2">
                {groupName} was created
            </Stack>
        )
    }
    const message =
        creator === userId ? (
            `You created ${groupName}`
        ) : (
            <Stack display="inline">
                <Box
                    display="inline"
                    color="default"
                    cursor="pointer"
                    data-testid="creator-name-clickable"
                    onClick={handleCreatorClick}
                >
                    {name}
                </Box>
                {` created ${groupName}`}
            </Stack>
        )

    return (
        <Stack centerContent paddingX="lg" paddingY="sm" color="gray2">
            <Stack
                centerContent
                direction={{ default: 'row', mobile: 'column' }}
                gap="sm"
                tooltip={<ProfileHoverCard userId={creator} />}
            >
                <Avatar userId={creator} size="avatar_xs" />
                <Paragraph textAlign={{ mobile: 'center' }}>{message}</Paragraph>
            </Stack>
        </Stack>
    )
}
